module.exports = __webpack_public_path__ + "static/media/SincerelyDiaryBookCover.a84077a5.jpg";